<template>
  <div>
    <div v-if="isJustDropped" class="product-badge">
      {{ badgeJustDroppedText }}
    </div>
    <div v-else-if="isComingSoon" class="product-badge">
      {{ badgeComingSoonText }}
    </div>
    <div v-else-if="priorityBadgeText" class="product-badge">
      {{ priorityBadgeText }}
    </div>
  </div>
</template>


<script>
  const TRUTHY_METAFIELD_VALUES = [true, 1, '1', 'true'];

  export default {
    name: 'ProductBadges',
    props: {
      productTags: {
        type: Array,
        required: false,
        default: () => [],
      },
      productId: {
        type: [Number, String],
        default: null,
      },
      comingSoon: {
        type: [Boolean, String, Number],
        default: false,
      },
      justDropped: {
        type: [Boolean, String, Number],
        default: false,
      },
    },
    computed: {
      isJustDropped() {
        return TRUTHY_METAFIELD_VALUES.includes(this.justDropped);
      },
      isComingSoon() {
        return TRUTHY_METAFIELD_VALUES.includes(this.comingSoon);
      },
      badgeJustDroppedText() {
        return window.theme?.strings?.badgeJustDropped || '';
      },
      badgeComingSoonText() {
        return window.theme?.strings?.badgeComingSoon || '';
      },
      priorityBadgeText() {
        const badgeKey = window.theme?.getProductBadgeKey?.(this.productTags, {
          productId: this.productId,
        });
        return window.theme?.getProductBadgeText?.(badgeKey) || '';
      },
    },
  }
</script>
